import { useEffect, useSyncExternalStore } from 'react';
import { getSyncer } from './runtime';
import type { SyncState } from './sync';
import { pruneSynced } from './queue';
import { getDb } from './db';
import { pruneSessions } from './sessions';

/** Реактивний стан черги: скільки чекає, чи йде відправка, чи є мережа. */
export function useSyncState(): SyncState {
  const syncer = getSyncer();
  return useSyncExternalStore(
    (listener) => syncer.subscribe(listener),
    () => syncer.getState(),
    () => syncer.getState(),
  );
}

/**
 * Запускає синхронізатор один раз за життя вкладки.
 * Навмисно НЕ зупиняє його на розмонтуванні: черга має жити, поки живе вкладка.
 */
export function useStartSync(): void {
  useEffect(() => {
    const syncer = getSyncer();
    void syncer.start();
    // Прибирання старого — раз на запуск, без поспіху.
    void pruneSynced(getDb()).catch(() => undefined);
    void pruneSessions().catch(() => undefined);
  }, []);
}
